import Navigator from '../components/Navigator/Navigator'
import useOnboardingSteps from './useOnboardingSteps'

export const useNavigator = (data: any) => {
	const steps = useOnboardingSteps()

	return <Navigator sections={steps} data={data} />
}
